/* Mirmedic — 100 errores de la preparación MIR */
(function(){
  function mirmedic_100_init(){
    var roots = Array.prototype.slice.call(document.querySelectorAll('.mm100'));
    if(!roots.length || window.mirmedic_100_ready) return;
    window.mirmedic_100_ready = true;
    var root = document; /* los bloques de Shopify pueden partir la página en varios contenedores */

    var imp = function(el, prop, val){ el.style.setProperty(prop, val, 'important'); };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var items = Array.prototype.slice.call(root.querySelectorAll('.mm100-item'));
    var secs  = Array.prototype.slice.call(root.querySelectorAll('.mm100-sec'));
    var tabs  = Array.prototype.slice.call(root.querySelectorAll('.mm100-tab'));
    var dots  = Array.prototype.slice.call(root.querySelectorAll('.mm100-dot'));
    var mapCount = root.querySelector('.mm100-mapcount em');
    var totalEl  = root.querySelector('.mm100-total em');
    var msgEl    = root.querySelector('.mm100-summsg');
    var filterBtn= root.querySelector('.mm100-filter');
    var topBtn   = root.querySelector('.mm100-top');
    var KEY = 'mm100-marks';

    /* ---- estado ---- */
    var marks = {};
    try{ var saved = sessionStorage.getItem(KEY); if(saved){ marks = JSON.parse(saved) || {}; } }catch(e){ marks = {}; }
    function save(){ try{ sessionStorage.setItem(KEY, JSON.stringify(marks)); }catch(e){} }

    /* ---- mapa de puntos: asignar categoría y color ---- */
    items.forEach(function(it, i){
      var sec = it.closest('.mm100-sec');
      it.setAttribute('data-idx', i);
      if(dots[i]){
        dots[i].setAttribute('data-cat', sec.id);
        dots[i].style.setProperty('--mm100-dotc', sec.getAttribute('data-hero'));
      }
    });

    /* ---- mensajes del resumen (nunca punitivos) ---- */
    function message(total, top){
      if(total === 0) return 'Aún no has marcado nada. Recorre las cinco categorías: lo útil no es el número, es reconocerlos.';
      if(total <= 8)  return 'Pocos y concretos. Empieza por los que están en ' + top + ': son los que más netas mueven.';
      if(total <= 20) return 'Lo normal en una preparación seria. El bloque con más marcas es ' + top + ': es tu primer frente.';
      if(total <= 40) return 'Muchos de estos errores se sostienen entre sí. Corregir los de ' + top + ' suele arrastrar a varios de los demás.';
      return 'Marcar tantos no es mala señal: significa que los has reconocido. Empieza por ' + top + ' y deja el resto para más adelante.';
    }

    /* ---- radar (pentágono animado) ---- */
    var CATS = ['estudio','repaso','simulacro','examen','mentalidad'];
    var RC = { x:160, y:152, r:104 };
    var radarTarget = {}, radarNow = {}, radarAnim = null;
    CATS.forEach(function(c){ radarTarget[c] = 0; radarNow[c] = 0; });
    var shape = root.querySelector('.mm100-shape');
    function rpt(i, v){ var a = -Math.PI/2 + i*2*Math.PI/5; return [RC.x + RC.r*v*Math.cos(a), RC.y + RC.r*v*Math.sin(a)]; }
    function drawRadar(){
      if(!shape) return;
      var pts = [];
      CATS.forEach(function(c, i){
        var p = rpt(i, radarNow[c]); pts.push(p[0].toFixed(1) + ',' + p[1].toFixed(1));
        var v = root.querySelector('.mm100-vertex[data-cat="' + c + '"]');
        if(v){ v.setAttribute('cx', p[0].toFixed(1)); v.setAttribute('cy', p[1].toFixed(1)); v.setAttribute('r', radarNow[c] > 0.01 ? 5 : 0); }
      });
      shape.setAttribute('points', pts.join(' '));
    }
    function animateRadar(){
      if(reduce){ CATS.forEach(function(c){ radarNow[c] = radarTarget[c]; }); drawRadar(); return; }
      if(radarAnim) cancelAnimationFrame(radarAnim);
      var from = {}, t0 = null, dur = 600;
      CATS.forEach(function(c){ from[c] = radarNow[c]; });
      var step = function(ts){
        if(!t0) t0 = ts;
        var p = Math.min((ts - t0)/dur, 1);
        /* rebote suave al final */
        var e = p < 1 ? 1 - Math.pow(1 - p, 3) * Math.cos(p * Math.PI * 0.5) : 1;
        var s = 1 + Math.sin(p * Math.PI) * 0.06;
        CATS.forEach(function(c){ radarNow[c] = from[c] + (radarTarget[c] - from[c]) * e; });
        drawRadar();
        if(p < 1){ radarAnim = requestAnimationFrame(step); } else { radarAnim = null; }
      };
      radarAnim = requestAnimationFrame(step);
    }

    /* ---- actualizar todo ---- */
    function update(){
      var total = 0, best = null, bestN = -1;
      secs.forEach(function(sec){
        var list = sec.querySelectorAll('.mm100-item');
        var n = 0;
        Array.prototype.forEach.call(list, function(it){ if(it.classList.contains('on')) n++; });
        total += n;
        var id = sec.id, name = sec.getAttribute('data-name');
        if(n > bestN){ bestN = n; best = name; }
        /* barra de sección */
        var bar = sec.querySelector('.mm100-secbar i'); if(bar) imp(bar, 'width', (n/list.length*100) + '%');
        var meta = sec.querySelector('.mm100-secmeta b'); if(meta) meta.textContent = n;
        /* pestaña */
        tabs.forEach(function(t){ if(t.getAttribute('data-target') === id){ var b = t.querySelector('b'); if(b) b.textContent = n; } });
        /* radar del resumen */
        radarTarget[id] = n / list.length;
        var rn = root.querySelector('.mm100-rnum[data-cat="' + id + '"]');
        if(rn && rn.textContent.trim() !== String(n)){ rn.textContent = ' ' + n; var lb = rn.parentNode; lb.classList.remove('bump'); void lb.getBBox(); lb.classList.add('bump'); }
        /* vacío en modo filtro */
        var ul = sec.querySelector('.mm100-list'); if(ul) ul.classList.toggle('none', n === 0);
      });
      if(mapCount) mapCount.textContent = total;
      if(totalEl) totalEl.textContent = total;
      if(msgEl){ msgEl.textContent = message(total, best); }
      animateRadar();
    }

    /* ---- marcar / desmarcar ---- */
    items.forEach(function(it, i){
      var btn = it.querySelector('.mm100-mark');
      var id = it.getAttribute('data-id');
      if(marks[id]){ it.classList.add('on'); if(dots[i]) dots[i].classList.add('on'); btn.setAttribute('aria-pressed','true'); }
      btn.addEventListener('click', function(){
        var on = !it.classList.contains('on');
        it.classList.toggle('on', on);
        if(dots[i]) dots[i].classList.toggle('on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if(on){ marks[id] = 1; } else { delete marks[id]; }
        save(); update();
      });
    });

    /* ---- filtro: solo marcados ---- */
    if(filterBtn){
      filterBtn.addEventListener('click', function(){
        var on = !roots[0].classList.contains('mm100-only');
        roots.forEach(function(r){ r.classList.toggle('mm100-only', on); });
        filterBtn.classList.toggle('on', on);
        filterBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* ---- pestañas: scroll suave ---- */
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var sec = document.getElementById(t.getAttribute('data-target'));
        if(!sec) return;
        var navH = (root.querySelector('.mm100-nav') || {offsetHeight:60}).offsetHeight; var y = sec.getBoundingClientRect().top + window.pageYOffset - navH - (parseInt((root.querySelector('.mm100-nav')||{style:{top:0}}).style.top,10)||0) - 10;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* ---- scroll-spy + aparición por sección ---- */
    if('IntersectionObserver' in window){
      var spyTick = false;
      var spy = function(){
        spyTick = false;
        var mid = window.pageYOffset + window.innerHeight * 0.42, cur = secs[0];
        secs.forEach(function(s){ if(s.getBoundingClientRect().top + window.pageYOffset <= mid) cur = s; });
        tabs.forEach(function(t){ t.classList.toggle('active', t.getAttribute('data-target') === cur.id); });
      };
      window.addEventListener('scroll', function(){ if(!spyTick){ spyTick = true; requestAnimationFrame(spy); } }, { passive: true });
      spy();

      var reveal = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var list = en.target.querySelectorAll('.mm100-item');
          Array.prototype.forEach.call(list, function(it, k){
            if(reduce){ it.classList.add('in'); return; }
            setTimeout(function(){ it.classList.add('in'); }, Math.min(k, 8) * 45);
          });
          reveal.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      secs.forEach(function(s){ reveal.observe(s); });
    } else {
      items.forEach(function(it){ it.classList.add('in'); });
    }

    /* ---- barra de bloques fija al hacer scroll (independiente del contenedor de Shopify) ---- */
    var nav = root.querySelector('.mm100-nav');
    if(nav && roots[0]){
      var ph = document.createElement('div'); ph.className = 'mm100-navph';
      nav.parentNode.insertBefore(ph, nav);
      var fixed = false, navTop = 0, offset = 0;
      /* cabecera del tema: seguirla en cada frame (las cabeceras móviles se ocultan y reaparecen al hacer scroll) */
      var headerSel = '#shopify-section-header header, .shopify-section-header header, .shopify-section-group-header-group header, header.header, .header-wrapper, .site-header, header';
      function headerEl(){
        var list = document.querySelectorAll(headerSel);
        for(var i = 0; i < list.length; i++){
          var el = list[i]; if(nav.contains(el) || el.contains(nav)) continue;
          var cs = window.getComputedStyle(el);
          if(cs.display === 'none' || cs.visibility === 'hidden') continue;
          var r = el.getBoundingClientRect();
          if(r.width > 0 && r.height > 0) return el;
        }
        return null;
      }
      var hdr = headerEl();
      function headerOffset(){
        if(!hdr || !document.body.contains(hdr)) hdr = headerEl();
        if(hdr){
          var r = hdr.getBoundingClientRect();
          /* solo cuenta si la cabecera está pegada arriba; si se ha desplazado o escondido (transform), su bottom <= 0 y el hueco es 0 */
          if(r.top <= 1 && r.bottom > 0) return Math.round(r.bottom);
          return 0;
        }
        var prev = nav.style.pointerEvents; nav.style.pointerEvents = 'none';
        var el = document.elementFromPoint(Math.floor(window.innerWidth/2), 4), off = 0;
        nav.style.pointerEvents = prev;
        while(el && el !== document.body && el !== document.documentElement){
          var cs2 = window.getComputedStyle(el);
          if(cs2.position === 'fixed' || cs2.position === 'sticky'){ off = Math.max(off, el.getBoundingClientRect().bottom); break; }
          el = el.parentElement;
        }
        return Math.max(0, Math.round(off));
      }
      function measure(){
        var r = roots[0].getBoundingClientRect();
        navTop = ph.getBoundingClientRect().top + window.pageYOffset;
        imp(nav, 'left', r.left + 'px'); imp(nav, 'width', r.width + 'px');
        imp(ph, 'height', nav.offsetHeight + 'px');
      }
      function place(){
        if(!fixed){ navTop = nav.getBoundingClientRect().top + window.pageYOffset; }
        var should = window.pageYOffset > navTop - offset;
        if(should && !fixed){
          fixed = true; ph.classList.add('on');
          imp(ph, 'height', nav.offsetHeight + 'px');
          nav.classList.add('fixed');
          /* sacarla del bloque: un ancestro con transform/filter del tema anula position:fixed */
          document.body.appendChild(nav);
          offset = headerOffset(); imp(nav, 'top', offset + 'px');
          measure();
        } else if(!should && fixed){
          fixed = false; nav.classList.remove('fixed'); ph.classList.remove('on');
          ph.parentNode.insertBefore(nav, ph.nextSibling);
          nav.style.removeProperty('left'); nav.style.removeProperty('width'); nav.style.removeProperty('top');
        } else if(fixed){
          var off2 = headerOffset(); if(off2 !== offset){ offset = off2; imp(nav, 'top', offset + 'px'); }
        }
      }
      var navTick = false;
      var follow = 0;
      function loop(){ place(); if(follow-- > 0) requestAnimationFrame(loop); }
      window.addEventListener('scroll', function(){ follow = 24; if(!navTick){ navTick = true; requestAnimationFrame(function(){ navTick = false; loop(); }); } }, { passive: true });
      window.addEventListener('resize', function(){ if(fixed) measure(); });
      place();
    }

    /* ---- volver arriba ---- */
    if(topBtn){
      var onScroll = function(){ topBtn.classList.toggle('show', window.pageYOffset > 900); };
      window.addEventListener('scroll', onScroll, { passive: true });
      topBtn.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    }

    /* ---- contador del hero (una sola vez) ---- */
    var big = root.querySelector('.mm100-hero-title [data-count]');
    if(big && !reduce){
      var target = parseInt(big.getAttribute('data-count'), 10), start = null;
      var step = function(ts){
        if(!start) start = ts;
        var p = Math.min((ts - start) / 900, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        big.textContent = Math.round(target * eased);
        if(p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    update();
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', mirmedic_100_init); }
  else { mirmedic_100_init(); }
})();
